import React from 'react';
import CaseDetailsHeader from 'components/CaseDetails/CaseDetailsHeader/CaseDetailsHeader';
import { SingleCaseComp, SingleCaseCompSubmitted } from 'components/CaseDetails/SingleCaseComp';
import './CaseDetails.css';

const CaseDetails = ({ submittedCase = false }) => (
    <div className="case-details">
        <CaseDetailsHeader submittedCase={submittedCase} />
        <div className="case-details__content_wrapper">
            {submittedCase ? <SingleCaseCompSubmitted /> : <SingleCaseComp />}
        </div>
    </div>
);

export default CaseDetails;
